import * as actions from "../actions";
import * as actionsTypes from "../actionTypes";
import {put, takeEvery, all, fork} from "redux-saga/effects";
import Service from '../../services/service.service'
import LabelService from "../../services/label.service";
import {ADD_CP_SERVICE_START} from "../actionTypes";


function* getCpServicesList(action) {
  try {
    if (action.payload) {
      const page = action.payload?.pageNo;
      const pageSize = action.payload?.pageSize;
      const cp_profile_id = action.payload?.id;
      const search = action.payload?.search;
      let params = {page, pageSize, cp_profile_id, search};

      const response = yield Service.cpServicesList(params);
      if (response?.data.statusCode === 200) {
        yield put(actions.getCpServicesListSuccess(response.data.data));
      } else {
        yield put(actions.getCpServicesListFailure("network error"));
      }
    }
  } catch (err) {
    console.log(err.response)
    let error = err?.response?.data?.message
    if (!error) {
      error = 'network error'
    }
    yield put(actions.getCpServicesListFailure(error));
  }
}

function* getCpServicesListSaga() {
  yield takeEvery(actionsTypes.GET_CP_SERVICES_LIST_START, getCpServicesList);
}

function* addCpService(action) {
  try {
    if (action.payload) {
      const response = yield Service.createCpService(action.payload);
      console.log({response})
      if (response?.data.statusCode) {
        yield put(actions.addCpServiceSuccess(response?.data));
      } else {
        yield put(actions.addCpServiceFailure("no data"));
      }
    }
  } catch (err) {
    let error = err?.response?.data?.message;

    if (!error) {
      error = "network error"
    }
    yield put(actions.addCpServiceFailure(error));
  }
}

function* addCpServiceSaga() {
  yield takeEvery(actionsTypes.ADD_CP_SERVICE_START, addCpService);
}
export function* cpServicesSaga() {
  yield all([fork(getCpServicesListSaga),fork(addCpServiceSaga)]);
}
